export var EReminderStatus;
(function (EReminderStatus) {
    EReminderStatus["Active"] = "active";
    EReminderStatus["Paused"] = "paused";
    EReminderStatus["Cancelled"] = "cancelled";
    EReminderStatus["Completed"] = "completed";
})(EReminderStatus || (EReminderStatus = {}));
//# sourceMappingURL=memoryReminders.types.js.map